import React from "react";
import Header from "../../../Header/Header";
import Footer from "../../../Footer/Footer";
import InnerPage from "./Innerpage";

const InnerPortfolio = () => {
  return (
    <>
      <Header />
      <InnerPage />
      <Footer />
    </>
  );
};

export default InnerPortfolio;
